module.exports = __webpack_public_path__ + "static/media/banner_Baccarat-half.f98e6e4c.png";